import { render } from "./PageSubTitle.vue?vue&type=template&id=2a596ba4&scoped=true"
import script from "./PageSubTitle.vue?vue&type=script&lang=js"
export * from "./PageSubTitle.vue?vue&type=script&lang=js"

import "./PageSubTitle.vue?vue&type=style&index=0&id=2a596ba4&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a596ba4"]])

export default __exports__